import StickyHeader from 'sticky_header/scripts/sticky_header'

$(function () {
  StickyHeader.init()
})
